import { PreferencesState } from 'types/app/preferences';

export const preferencesInitialState: PreferencesState = {};
